import Rest from '@services/Rest';

/**
 * @typedef {SalesBannerProxyService}
 */
export default class SalesBannerProxyService extends Rest {
  /**
   * @type {String}
   */
  static resource = '/sales/banner'
}
